import { ReactComponent as CheckMark } from '@public/icons/check.svg';
import { classNames } from '@utils/class-names';
import { roundIconStyles } from '@utils/constants';
import React from 'react';
export const Check = ({ checked, fill = 'fill-green', className }) => {
    return (React.createElement("div", { className: classNames(!checked && 'border border-green/30', roundIconStyles, className), "data-testid": "Check" }, checked && React.createElement(CheckMark, { className: `w-full h-full ${fill}` })));
};
